import { useMutation } from "react-query";
import { ITeamsUserInvite } from "types/TeamUsersResponse";

import api from "../api";

const userInviteService = async ({
  teamId,
  emails,
  templateId,
}: {
  teamId: number;
  emails: string[];
  templateId?: number;
}) => {
  const { data } = await api.post<ITeamsUserInvite>(
    `/profile/teams/${teamId}/users`,
    {
      emailIds: emails,
      ...(templateId !== undefined && { template_id: templateId }),
    },
  );
  return data;
};

export const useUserInvite = () => {
  const [mutate, { ...mutationProps }] = useMutation(userInviteService);

  return {
    mutate,
    ...mutationProps,
  };
};
